import React, { useState } from "react";
import { Radio, Space } from "antd";
import { withErrorBoundary } from "../ErrorBoundary/withErrorBoundary";
import UpdateEmail from "../UpdateEmail/UpdateEmail";
import UpdatePassword from "../UpdatePassword/UpdatePassword";

const LoginInformation = () => {
   const [value, setValue] = useState({
      updateEmail: null,
      updatePassword: null
   });

   const onChange = (e) => {
      setValue({ ...value, partOne: e.target.value, partTwo: null });
   };

   return (
      <>
         <div className="loginInformation accountSettings">
            <div className="changeEmailOrPassword">
               <p className="title">Log in information</p>
               <div className="my-8">
                  <h4>Update email or password</h4>
               </div>
               <p className="label-text mt-8 mb-5">
                  Select an option to proceed with updating your email or password.
               </p>
               <Radio.Group onChange={onChange} value={value.partOne}>
                  <Space direction="vertical">
                     <Radio value={1}>Update email</Radio>
                     <Radio value={2}>Update password</Radio>
                  </Space>
               </Radio.Group>

               {value.partOne === 1 ? (
                  <UpdateEmail />
               ) : value.partOne === 2 ? (
                  <UpdatePassword />
               ) : null}
            </div>
         </div>
      </>
   );
};

export default withErrorBoundary(LoginInformation);
